import { useEffect, useRef } from "react";
import { gsap, motionOK } from "../hooks/useSmoothScroll";
import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const About = () => {
  const ref = useRef(null);
  const { t } = useLang();

  useEffect(() => {
    if (!motionOK()) return undefined;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".about-inner",
        { yPercent: -5 },
        {
          yPercent: 5,
          ease: "none",
          scrollTrigger: { trigger: ref.current, start: "top bottom", end: "bottom top", scrub: true },
        }
      );
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={ref} id="about" className="bg-white text-[#202020] py-24 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div
            className="relative aspect-[3/4] max-w-md bg-stone border hairline-light overflow-hidden"
            data-testid="founder-photo"
          >
            <img
              src="/images/natalia.webp"
              alt={t.UI.founderPhotoAlt}
              className="about-inner absolute inset-0 h-full w-full object-cover object-top scale-110"
              loading="lazy"
            />
            <span className="absolute inset-4 border border-champagne/50 pointer-events-none" aria-hidden="true" />
          </div>
        </Reveal>
        <div>
          <Reveal>
            <img
              src="/images/le-capital-logo.webp"
              alt={t.UI.logoAlt}
              className="w-16 h-16 md:w-[4.5rem] md:h-[4.5rem] rounded-full mb-8"
              loading="lazy"
              data-testid="about-logo"
            />
            <p className="label-caps">{t.UI.aboutLabel}</p>
            <h2 className="mt-4 font-serif-lux font-light text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
              {t.UI.aboutTitle}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5">
              {t.UI.aboutBio.map((p) => (
                <p key={p.slice(0, 20)} className="text-smoke leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-10 border-s-2 border-champagne ps-6">
              <p className="font-serif-lux text-2xl font-medium">{t.UI.founderName}</p>
              <p className="mt-1 text-[0.68rem] uppercase tracking-[0.22em] text-smoke">{t.UI.founderRole}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
